import { lazy } from "react";
import Loadable from "../../../layout/fullLayout/loadable/loadable";
import { MASTER_ORGANIZATION_PATH, MASTER_PATH } from "../Masterpath/Master.path";
import { AuthorizedRoute } from "../../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../../constants/enums";

const Organization = Loadable(
	lazy(() =>
		import("../Organzation/OrganizationList").then(({ OrganizationList }) => ({
			default: OrganizationList,
		}))
	)
);
const Course = Loadable(
	lazy(() =>
		import("../Course/CourseList").then(({ CourseList }) => ({
			default: CourseList,
		}))
	)
);
const Session = Loadable(
	lazy(() =>
		import("../Session/SessionList").then(({ SessionList }) => ({
			default: SessionList,
		}))
	)
);

export const MasterRouter=[

    {
		path: MASTER_ORGANIZATION_PATH,
		exact: true,
		element: (
			<AuthorizedRoute
				allowFullAccess
				moduleIds={[ALLOWED_MODULES.ORGANIZATION]}
			>
				<Organization />
			</AuthorizedRoute>
		),
	},
    {
		path: MASTER_PATH+`/course`,
		exact: true,
		element: (
			<AuthorizedRoute
				allowFullAccess
				moduleIds={[ALLOWED_MODULES.COURSE]}
			>
				<Course />
			</AuthorizedRoute>
		),
	},
    {
		path: MASTER_PATH+`/session`,
		exact: true,
		element: (
			<AuthorizedRoute
				allowFullAccess
				moduleIds={[ALLOWED_MODULES.SESSION]}
			>
				<Session />
			</AuthorizedRoute>
		),
	},

]